function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Visa",
  transform: "translate(-647.614 -636.441)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_331",
  "data-name": "Rectangle 331",
  width: 38.1,
  height: 26.83,
  rx: 2,
  transform: "translate(647.614 636.441)",
  fill: "#0066b2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  d: "M780.367,728.678h-1.985l1.24-7.622h1.985Z",
  transform: "translate(-115.32 -74.619)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  d: "M712.827,721.054l-1.892,5.242-.224-1.129h0l-.668-3.428a.849.849,0,0,0-.941-.686h-3.127l-.037.129a7.408,7.408,0,0,1,2.076.871l1.724,6.622H711.8l3.157-7.622Z",
  transform: "translate(-51.434 -74.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_174",
  "data-name": "Path 174",
  d: "M857.281,728.679H859.1l-1.589-7.622h-1.6a.912.912,0,0,0-.916.568l-2.959,7.054h2.068l.413-1.132h2.523Zm-2.183-2.7,1.043-2.852.587,2.852Z",
  transform: "translate(-180.28 -74.62)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_175",
  "data-name": "Path 175",
  d: "M811.184,721.871l.284-1.637a5.732,5.732,0,0,0-1.785-.332c-.985,0-3.323.431-3.323,2.523,0,1.969,2.745,1.994,2.745,3.028s-2.462.849-3.274.2l-.3,1.711a5.559,5.559,0,0,0,2.24.431c1.354,0,3.4-.7,3.4-2.61,0-1.982-2.769-2.166-2.769-3.028S810.335,721.4,811.184,721.871Z",
  transform: "translate(-139.265 -73.602)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M710.711,725.171l-.668-3.427a.85.85,0,0,0-.941-.686h-3.127l-.037.129a7.691,7.691,0,0,1,2.945,1.479A5.943,5.943,0,0,1,710.711,725.171Z",
  transform: "translate(-51.434 -74.62)",
  fill: "#f9a533"
}));

function SvgIcVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.1,
    height: 26.83,
    viewBox: "0 0 38.1 26.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisa);
export default ForwardRef;